import { useState } from 'react';
import { StickyNote, Trash2 } from 'lucide-react';
import { TipoNota, formatarDataHora, type NotaDto } from '@nexital/shared';
import { Avatar } from '../design-system/Avatar';
import { useConfirmar } from '../design-system/Confirmacao';
import { useNotas } from '../notas/contexto-notas';
import '../notas/notas.css';
import { Modulo } from './Modulo';

/**
 * "Notas do processo" (RQ-NOT-002): notas de lista da licitação, sempre públicas para quem vê o processo.
 * Os post-its ficam soltos no quadro da licitação. Usa o store de notas da licitação aberta (ProvedorNotas dela).
 */
export function ModuloNotas() {
  const todas = useNotas((s) => s.notas);
  const criar = useNotas((s) => s.criarNotaDeLista);
  const excluirNota = useNotas((s) => s.excluirNota);
  const confirmar = useConfirmar();
  const excluir = async (uuid: string) => {
    if (await confirmar({ titulo: 'Excluir a nota?', mensagem: 'A nota sai da licitação para todos. Não dá para desfazer.', rotulo: 'Excluir' })) void excluirNota(uuid);
  };
  const [texto, setTexto] = useState('');
  const notas = todas.filter((n: NotaDto) => n.tipo === TipoNota.DoProcesso);

  const enviar = async () => {
    if (!texto.trim()) return;
    if (await criar(texto.trim())) setTexto('');
  };

  const extra = <span className="pilula pilula--informacao">{notas.length}</span>;
  return (
    <Modulo titulo="Notas do processo" Icone={StickyNote} cor="amarelo" extra={extra}>
      {notas.length === 0 && <p className="modulo__vazio">Nenhuma nota ainda.</p>}
      <ul className="notas-processo">
        {notas.map((nota) => (
          <li key={nota.uuid} className="notas-processo__item">
            <Avatar nome={nota.autor.nome} chave={nota.autor.uuid} tamanho={24} />
            <div>
              <div className="notas-processo__meta">
                {nota.autor.nome} · {formatarDataHora(nota.criadoEm)}
              </div>
              <div>{nota.texto}</div>
            </div>
            {nota.podeEditar && (
              <button type="button" className="botao-icone" aria-label="Excluir nota" onClick={() => void excluir(nota.uuid)}>
                <Trash2 size={16} />
              </button>
            )}
          </li>
        ))}
      </ul>
      <form
        className="notas-processo__nova"
        onSubmit={(e) => {
          e.preventDefault();
          void enviar();
        }}
      >
        <input className="campo" value={texto} onChange={(e) => setTexto(e.target.value)} placeholder="Escreva uma nota…" aria-label="Nova nota" maxLength={20000} />
        <button type="submit" className="botao botao--primario" disabled={!texto.trim()}>
          Anotar
        </button>
      </form>
    </Modulo>
  );
}
